const step_up = {
    verify_your_identity: 'Verifique su identidad',
    choose_method_description: 'Para continuar, confirme que es usted con uno de los siguientes métodos.',
    password: 'Contraseña',
    password_description: 'Ingrese la contraseña de su cuenta',
    enter_password_description: 'Ingrese la contraseña de su cuenta para continuar.',
    enter_verification_code_description: 'Ingrese el código de verificación enviado a {{identifier}}.',
    subject_proof_description: 'Para continuar, confirme que es usted a través de una cuenta vinculada a la suya. Después podrá configurar un método de verificación.',
    no_method_available: 'No hay ningún método de verificación disponible',
    no_method_available_description: 'Su cuenta no tiene ningún método que pueda completar esta verificación. Por favor, contacte a su administrador para obtener ayuda.',
};
export default Object.freeze(step_up);
